"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const table_1 = require("../../components/web-view/table");
const button_1 = require("primereact/button");
const tag_1 = require("primereact/tag");
const useIsMobile_1 = require("../../hooks/mobile/useIsMobile");
const react_i18next_1 = require("react-i18next");
const statusHelpers_1 = require("../../common/utils/statusHelpers");
const machineList_module_scss_1 = __importDefault(require("./machineList.module.scss"));
const ApiMachineRepo_1 = require("../../modules/machine/infra/ApiMachineRepo");
const getAll_1 = require("../../modules/club/app/getAll");
const react_router_dom_1 = require("react-router-dom");
const datesHelpers_1 = require("../../common/utils/datesHelpers");
const ApiClubRepo_1 = require("../../modules/club/infra/ApiClubRepo");
const useDebounce_1 = require("../../hooks/debounce/useDebounce");
const FiltersComponent_1 = require("./FiltersComponent");
const usePagination_1 = require("../../hooks/pagination/usePagination");
const FilterContext_1 = require("../../context/filters/FilterContext");
const progressspinner_1 = require("primereact/progressspinner");
const skeleton_1 = require("primereact/skeleton");
const SelectStatusFilter_1 = require("../../components/filter/SelectStatusFilter");
const dropdown_1 = require("primereact/dropdown");
const inputtext_1 = require("primereact/inputtext");
const RoleType_1 = require("../../common/enums/RoleType");
const AuthContext_1 = require("../../hooks/auth/context/AuthContext");
const MachineList = () => {
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { filters, setFilters } = (0, FilterContext_1.useFilters)();
    const { hasRole } = (0, AuthContext_1.useAuth)();
    const [clubs, setClubs] = (0, react_1.useState)([]);
    const [selectedClub, setSelectedClub] = (0, react_1.useState)(filters.clubId || '');
    const [globalFilterValue, setGlobalFilterValue] = (0, react_1.useState)(filters.globalFilterValue || '');
    const [error, setError] = (0, react_1.useState)(null);
    const [clubId, setClubId] = (0, react_1.useState)('');
    const [statusValue, setStatusValue] = (0, react_1.useState)(filters.status || '');
    const debouncedFilterValue = (0, useDebounce_1.useDebounce)(globalFilterValue);
    const debouncedSelectedClub = (0, useDebounce_1.useDebounce)(selectedClub);
    const isInitialLoadRef = (0, react_1.useRef)(true);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(() => {
        const storedPage = localStorage.getItem('currentPage');
        return storedPage ? parseInt(storedPage, 10) : 1;
    });
    const machineRepo = (0, ApiMachineRepo_1.createApiMachineRepo)();
    const fetchClubs = (0, react_1.useCallback)(async () => {
        const clubRepo = (0, ApiClubRepo_1.createApiClubRepo)();
        try {
            const clubList = await (0, getAll_1.getAll)(clubRepo);
            if (clubList) {
                const formattedClubs = clubList.map((club) => ({
                    label: club.clubName,
                    value: club.clubName,
                    id: club.clubId,
                }));
                setClubs(formattedClubs);
            }
            else {
                console.error('Product list is empty or undefined:', clubList);
            }
        }
        catch (error) {
            console.error('Error fetching clubs:', error);
        }
    }, []);
    const fetchMachines = (0, react_1.useCallback)(async (page = 1, pageSize = 10) => {
        const club = clubs.find((club) => {
            return club.value === selectedClub;
        })?.id;
        setClubId(club || '');
        try {
            const response = await machineRepo.getAll(page, pageSize, club, debouncedFilterValue.trim(), statusValue);
            return response;
        }
        catch (err) {
            console.error('Fetch error:', err);
            setError('Error al cargar los datos');
            throw err;
        }
    }, [clubs, selectedClub, debouncedFilterValue, machineRepo]);
    const { data, loading, fetchData } = (0, usePagination_1.usePagination)(parseInt(localStorage.getItem('currentPage') || '1', 10), 10, fetchMachines, (machine) => machine.micronMachineId);
    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem('currentPage', page.toString());
        fetchData(page, 10);
    };
    const resetPageAndFetch = (newFilters) => {
        setCurrentPage(1);
        localStorage.setItem('currentPage', '1');
        setGlobalFilterValue(newFilters.globalFilterValue);
        setFilters(newFilters);
    };
    const onClubChange = (0, react_1.useCallback)((clubId) => {
        setSelectedClub(clubId);
        setFilters({
            globalFilterValue: filters.globalFilterValue || '',
            startDate: filters.startDate || null,
            endDate: filters.endDate || null,
            clubId: clubId || null,
        });
    }, []);
    const onGlobalFilterChange = (e) => {
        const newFilters = {
            globalFilterValue: e,
            startDate: filters.startDate,
            endDate: filters.endDate,
            clubId: filters.clubId,
        };
        resetPageAndFetch(newFilters);
    };
    (0, react_1.useEffect)(() => {
        if (selectedClub && clubs.length > 0) {
            const club = clubs.find((club) => club.value === selectedClub)?.id;
            setClubId(club || '');
        }
    }, [selectedClub, clubs]);
    (0, react_1.useEffect)(() => {
        // Actualizar datos solo si los clubes ya están cargados
        if (isInitialLoadRef.current || clubs.length === 0)
            return;
        const fetchMachinesData = async () => {
            try {
                await fetchData(parseInt(localStorage.getItem('currentPage') || '1', 10), 10, false, debouncedFilterValue || '', [], [], statusValue);
            }
            catch (error) {
                console.error('Error fetching machines data:', error);
            }
        };
        fetchMachinesData();
    }, [debouncedFilterValue, debouncedSelectedClub, clubs.length, statusValue]);
    (0, react_1.useEffect)(() => {
        if (filters.clubId) {
            setSelectedClub(filters.clubId);
            isInitialLoadRef.current = false;
        }
        if (filters.globalFilterValue) {
            setGlobalFilterValue(filters.globalFilterValue);
            isInitialLoadRef.current = false;
        }
    }, [filters]);
    (0, react_1.useEffect)(() => {
        const fetchInitialClubData = async () => {
            if (clubs.length === 0) {
                await fetchClubs();
            }
        };
        if (!isInitialLoadRef.current) {
            fetchInitialClubData();
        }
    }, [isInitialLoadRef.current]);
    (0, react_1.useEffect)(() => {
        const fetchInitialData = async () => {
            try {
                if (clubs.length === 0) {
                    await fetchClubs();
                }
                await fetchData(parseInt(localStorage.getItem('currentPage') || '1', 10), 10, false, debouncedFilterValue || '');
            }
            catch (error) {
                console.error('Error en la carga inicial:', error);
            }
            finally {
                isInitialLoadRef.current = false;
            }
        };
        if (isInitialLoadRef.current) {
            fetchInitialData();
        }
    }, []);
    const columns = [
        {
            field: 'micronMachineId',
            header: 'machineId',
            renderFunc: (machine) => {
                if (!machine.micronMachineId)
                    return '';
                return (0, jsx_runtime_1.jsx)("div", { children: machine.micronMachineId });
            },
        },
        {
            field: 'machineName',
            header: 'name',
            renderFunc: (machine) => {
                if (!machine.machineName)
                    return '';
                return (0, jsx_runtime_1.jsx)("div", { className: "font-semibold", children: machine.machineName });
            },
        },
        {
            field: 'micronOnlineStatus',
            header: 'status',
            renderFunc: (machine) => ((0, jsx_runtime_1.jsx)(tag_1.Tag, { className: (0, statusHelpers_1.getStatusClass)(machine.micronOnlineStatus), children: (0, statusHelpers_1.getStatusName)(machine.micronOnlineStatus) })),
        },
        {
            field: 'clubName',
            header: 'clubLocation',
            renderFunc: (machine) => {
                if (!machine.clubId)
                    return '';
                return (0, jsx_runtime_1.jsx)("div", { className: "text-gray-700", children: machine.clubName });
            },
        },
        {
            field: 'onlineTime',
            header: 'machineOnlineTime',
            renderFunc: (machine) => {
                if (!machine.onlineTime)
                    return '';
                return ((0, jsx_runtime_1.jsx)("div", { className: "text-gray-700", children: (0, datesHelpers_1.formatDate)(machine.onlineTime.toString()) }));
            },
        },
    ];
    const handlerGotoDetail = (machine) => {
        navigate(`/machines/${machine.micronMachineId}?filter=${globalFilterValue}&clubId=${clubId}`, {
            state: { name: machine.machineName },
        });
    };
    const renderActionButtons = (machine) => ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-center gap-2", children: (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-eye", className: "p-button-rounded p-button-info p-button-outlined", onClick: () => handlerGotoDetail(machine) }) }));
    const handleStatusFilterChange = (status) => {
        setStatusValue(status === null ? '' : status);
        setCurrentPage(1);
        localStorage.setItem('currentPage', '1');
        setFilters({
            globalFilterValue: filters.globalFilterValue || '',
            startDate: filters.startDate || null,
            endDate: filters.endDate || null,
            clubId: filters.clubId || null,
            status: status === null ? '' : status,
        });
    };
    // Mobile infinite scroll
    const observerRef = (0, react_1.useRef)(null);
    const [isLoadingMore, setIsLoadingMore] = (0, react_1.useState)(false);
    const loadingRef = (0, react_1.useRef)(loading);
    const paginationRef = (0, react_1.useRef)(data.pagination);
    (0, react_1.useEffect)(() => {
        loadingRef.current = loading;
        paginationRef.current = data.pagination;
    }, [loading, data.pagination]);
    const loadMore = (0, react_1.useCallback)(() => {
        if (loadingRef.current ||
            !paginationRef.current ||
            paginationRef.current.currentPage >= paginationRef.current.totalPages) {
            return;
        }
        setIsLoadingMore(true);
        fetchData(paginationRef.current.currentPage + 1, paginationRef.current.pageSize, true).finally(() => {
            setIsLoadingMore(false);
        });
    }, [fetchData]);
    (0, react_1.useEffect)(() => {
        if (!isMobile || !observerRef.current)
            return;
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                loadMore();
            }
        }, { threshold: 0, rootMargin: '200px' });
        observer.observe(observerRef.current);
        return () => observer.disconnect();
    }, [isMobile, loadMore]);
    return ((0, jsx_runtime_1.jsx)("div", { children: isMobile ? ((0, jsx_runtime_1.jsxs)("div", { className: machineList_module_scss_1.default.mobileContainer, children: [(0, jsx_runtime_1.jsx)(SelectStatusFilter_1.SelectStatusFilter, { items: [
                        { name: 'Online', value: 'true' },
                        { name: 'Offline', value: 'false' },
                    ], value: statusValue, onChange: handleStatusFilterChange, mode: "legacy" }), (0, jsx_runtime_1.jsx)("div", { className: machineList_module_scss_1.default.mobileHeader, children: (0, jsx_runtime_1.jsxs)("div", { className: machineList_module_scss_1.default.mobileFilterRow, children: [(0, jsx_runtime_1.jsx)("div", { className: machineList_module_scss_1.default.dropdownContainer, children: (0, jsx_runtime_1.jsx)(dropdown_1.Dropdown, { value: selectedClub || null, options: clubs, onChange: (e) => {
                                        localStorage.removeItem('currentPage');
                                        onClubChange(e.value || '');
                                    }, filter: hasRole(RoleType_1.RoleType.ADMIN), optionLabel: "label", showClear: true, placeholder: t('byClub'), className: machineList_module_scss_1.default.dropdownInputMobile, style: { minWidth: '100px' } }) }), (0, jsx_runtime_1.jsxs)("div", { className: machineList_module_scss_1.default.searchInputContainer, children: [(0, jsx_runtime_1.jsx)("i", { className: `pi pi-search ${machineList_module_scss_1.default.inputIcon}` }), (0, jsx_runtime_1.jsx)(inputtext_1.InputText, { value: globalFilterValue, onChange: (e) => onGlobalFilterChange(e.target.value), placeholder: `${t('search')}...`, className: machineList_module_scss_1.default.searchInput }), globalFilterValue && ((0, jsx_runtime_1.jsx)("i", { className: `pi pi-times ${machineList_module_scss_1.default.clearIcon}`, onClick: () => onGlobalFilterChange('') }))] })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: machineList_module_scss_1.default.mobileList, children: [error && ((0, jsx_runtime_1.jsxs)("div", { className: machineList_module_scss_1.default.mobileError, children: [(0, jsx_runtime_1.jsx)("i", { className: "pi pi-exclamation-circle" }), (0, jsx_runtime_1.jsx)("span", { children: error })] })), loading &&
                            data.items.length === 0 &&
                            Array.from({ length: 6 }).map((_, i) => ((0, jsx_runtime_1.jsx)("div", { className: machineList_module_scss_1.default.machineCardSkeleton, children: (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { width: "100%", height: "76px", borderRadius: "16px" }) }, i))), data.items.length > 0 &&
                            data.items.map((machine, index) => ((0, jsx_runtime_1.jsxs)("div", { className: machineList_module_scss_1.default.machineCard, onClick: () => handlerGotoDetail(machine), style: { animationDelay: `${Math.min(index, 10) * 40}ms` }, children: [(0, jsx_runtime_1.jsx)("div", { className: `${machineList_module_scss_1.default.statusDot} ${machine.micronOnlineStatus
                                            ? machineList_module_scss_1.default.statusOnline
                                            : machineList_module_scss_1.default.statusOffline}` }), (0, jsx_runtime_1.jsxs)("div", { className: machineList_module_scss_1.default.machineCardContent, children: [(0, jsx_runtime_1.jsx)("span", { className: machineList_module_scss_1.default.machineName, children: machine.machineName || t('unknown') }), (0, jsx_runtime_1.jsxs)("div", { className: machineList_module_scss_1.default.machineCardMeta, children: [(0, jsx_runtime_1.jsx)("span", { className: machineList_module_scss_1.default.machineId, children: machine.micronMachineId }), machine.clubName && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: machineList_module_scss_1.default.metaSeparator, children: "\u00B7" }), (0, jsx_runtime_1.jsx)("span", { className: machineList_module_scss_1.default.machineClub, children: machine.clubName })] }))] })] }), (0, jsx_runtime_1.jsxs)("div", { className: machineList_module_scss_1.default.machineCardRight, children: [(0, jsx_runtime_1.jsx)(tag_1.Tag, { value: (0, statusHelpers_1.getStatusName)(machine.micronOnlineStatus), className: `${machineList_module_scss_1.default.statusPill} ${machine.micronOnlineStatus
                                                    ? machineList_module_scss_1.default.statusPillOnline
                                                    : machineList_module_scss_1.default.statusPillOffline}` }), (0, jsx_runtime_1.jsx)("i", { className: `pi pi-chevron-right ${machineList_module_scss_1.default.chevron}` })] })] }, machine.machineId || machine.micronMachineId))), !loading && data.items.length === 0 && !error && ((0, jsx_runtime_1.jsxs)("div", { className: machineList_module_scss_1.default.mobileEmpty, children: [(0, jsx_runtime_1.jsx)("i", { className: `pi pi-inbox ${machineList_module_scss_1.default.emptyIcon}` }), (0, jsx_runtime_1.jsx)("span", { children: t('noRecords') })] })), (0, jsx_runtime_1.jsx)("div", { ref: observerRef, style: { height: '1px' } }), isLoadingMore && ((0, jsx_runtime_1.jsx)("div", { className: machineList_module_scss_1.default.mobileLoadingMore, children: (0, jsx_runtime_1.jsx)(progressspinner_1.ProgressSpinner, { style: { width: '24px', height: '24px' }, strokeWidth: "6", fill: "var(--surface-ground)", animationDuration: ".5s" }) }))] })] })) : ((0, jsx_runtime_1.jsx)("div", { className: machineList_module_scss_1.default.machineListSpecialContainer, children: (0, jsx_runtime_1.jsx)(table_1.AppTable, { columns: columns, actions: renderActionButtons, fetchData: fetchData, data: data, loading: loading, reduceHeight: true, getKey: (item) => item.machineId, globalFilterFields: ['machineId', 'machineName'], headerContent: (0, jsx_runtime_1.jsx)("h2", { children: t('machinesList') }), currentPage: currentPage, handleCurrentPage: handlePageChange, filtersComponent: (0, jsx_runtime_1.jsx)(FiltersComponent_1.FiltersComponent, { clubs: clubs, selectedClub: selectedClub, onClubChange: onClubChange, globalFilterValue: globalFilterValue, onGlobalFilterChange: onGlobalFilterChange, statusValue: statusValue, onChangeStatusFilter: handleStatusFilterChange, statusItems: [
                        { name: 'Online', value: 'true' },
                        { name: 'Offline', value: 'false' },
                    ] }) }) })) }));
};
exports.MachineList = MachineList;
